import { http } from '@admin-base/core'

const prefix = '/'

// 课件列表
const coursewareList = data => {
    return http.post(prefix + 'api/resource/courseware/pageList', data)
}

// 视频/音频列表
const videoList = data => {
    return http.post(prefix + 'api/resource/video/pageList', data)
}

// 电子书列表
const ebookList = data => {
    return http.post(prefix + 'api/resource/ebook/pageList', data)
}

// 习题列表
const exerciseList = data => {
    return http.post(prefix + `api/question/problem/list`, data)
}

// 试卷列表
const testPaperList = data => {
    return http.post(prefix + `api/question/examPaper/list`, data)
}

// 试卷详情
const testPaperDetail = data => {
    return http.post(prefix + `api/question/examPaper/detail`, data)
}

export {
    coursewareList,
    videoList,
    ebookList,
    exerciseList,
    testPaperList,
    testPaperDetail,
}